import { View } from "dripsy";
import * as React from "react";

function SwipeBackTabFix() {
  return <View sx={{ position: "absolute", top: 0, bottom: 0, width: 15, left: 0 }} />;
}
export default SwipeBackTabFix;
